/*
 * "Complete your set" suggestion rules, shared by the landing page (assets/lp-v2.js)
 * and the cart drawer / cart page (assets/complete-your-set.js). No DOM here.
 *
 * FlabUpsellRules.suggestions(cart, data, opts) -> up to 3 suggestions
 *   cart: /cart.js JSON (items newest first)
 *   data: the JSON from snippets/upsell-data.liquid (theme settings → Complete your set)
 *   opts.anchor: handle of the set the shopper just added, if known
 *   opts.soldOut: { handle: true } for products found sold out since the page loaded
 *
 * After a set: 1) a 2-color set with none of the anchor set's colors (after the
 * featured OG set or another 4-color set in data.four: data.og_first), 2) an
 * expansion pack of the best-selling color not in their sets, 3) the target flab.
 * With only flabs in the cart: 1) enough flabs to make a color a multiple of the
 * pack size, or once every color is full, an expansion pack in a new color, 2) the
 * target if there isn't one, 3) the rope tool. Anything in the cart or sold out is
 * skipped.
 *
 * A set's colors come from its color- tags (data.set_tags, matched to each flab's own
 * color- tag); a set with none falls back to the Set colors setting (data.set_colors).
 */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function shortName(title) { return title.replace(/\s+flab$/i, ''); }

  // "set-handle: flab-handle, flab-handle" per line (theme setting).
  function parseSetColors(text) {
    var map = {};
    String(text || '').split(/\n/).forEach(function (line) {
      var m = line.split(':');
      if (m.length < 2) return;
      map[m[0].trim()] = m.slice(1).join(':').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    });
    return map;
  }

  function suggestions(cart, data, opts) {
    if (!cart || !data) return [];
    opts = opts || {};
    var soldOut = opts.soldOut || {};
    var PACK = parseInt(data.pack_size, 10) || 4;
    var PACK_OFF = parseFloat(data.pack_discount) || 0;
    var setColors = parseSetColors(data.set_colors);
    var flabs = data.flabs || [];
    var target = data.target;
    var list = [];

    // A set's colors as flab handles. Tags with no flab for sale (color-lake-blue) are
    // kept as the tag, so they never match anything but don't fall back either.
    function colorsOf(handle) {
      var tags = (data.set_tags || {})[handle];
      if (!tags || !tags.length) return setColors[handle] || [];
      return tags.map(function (t) {
        var f = flabs.filter(function (x) { return (x.colors || []).indexOf(t) !== -1; })[0];
        return f ? f.handle : t;
      });
    }
    function shares(a, b) { return a.some(function (h) { return b.indexOf(h) !== -1; }); }
    function available(p) { return !!p && p.available && !soldOut[p.handle]; }
    function flabByHandle(h) { return flabs.filter(function (f) { return f.handle === h; })[0]; }
    function qtyInCart(handle) {
      var n = 0;
      cart.items.forEach(function (i) { if (i.handle === handle) n += i.quantity; });
      return n;
    }
    function inCart(handle) { return qtyInCart(handle) > 0; }
    function colorInCart(f) { return inCart(f.handle) || !!(f.pack && inCart(f.pack.handle)); }
    // A cart line's flab color and how many flabs it holds (a 4-pack product counts as PACK).
    function flabLine(item) {
      var f = flabByHandle(item.handle);
      if (f) return { flab: f, count: item.quantity };
      f = flabs.filter(function (x) { return x.pack && x.pack.handle === item.handle; })[0];
      return f ? { flab: f, count: item.quantity * PACK } : null;
    }

    // Single flabs already in the cart: the pack discount comes off every flab
    // once the cart holds PACK or more of them.
    var singles = 0;
    cart.items.forEach(function (i) { if (flabByHandle(i.handle)) singles += i.quantity; });

    function flabItem(f, kind, qty, note, title) {
      if (kind === 'pack' && f.pack) {
        // A real 4-pack product (Shopify Bundles) at its own price.
        return { kind: kind, handle: f.pack.handle, title: title || f.pack.title, variant: f.pack.variant, qty: 1, price: f.pack.price, price_text: money(f.pack.price), note: note, image: f.pack.image || f.image };
      }
      // Shopify takes the pack discount off each flab and drops the fraction of a cent.
      var isFlab = !!flabByHandle(f.handle);
      var each = isFlab && PACK_OFF && singles + qty >= PACK ? f.price - Math.floor(f.price * PACK_OFF / 100) : f.price;
      var price = each * qty;
      return { kind: kind, handle: f.handle, title: title || f.title, variant: f.variant, qty: qty, price: price, price_text: money(price), note: note, image: f.image };
    }

    // An expansion pack in a color that isn't in the cart or in `used` (the colors of
    // their sets), skipping the target color: the featured pack color first (data.pack_first,
    // Cornflower), else the best seller.
    function expansionPack(used) {
      var open = flabs.filter(function (x) {
        if (colorInCart(x) || used.indexOf(x.handle) !== -1) return false;
        if (!(x.pack ? available(x.pack) : available(x))) return false;
        return !(data.skip_target_packs && target && x.handle === target.handle);
      });
      var f = open.filter(function (x) { return data.pack_first && x.handle === data.pack_first; })[0] || open[0];
      return f ? flabItem(f, 'pack', PACK, 'Expansion pack: ' + PACK + ' flabs in a new color.', shortName(f.title) + ' ' + PACK + '-pack') : null;
    }

    var sets = cart.items.filter(function (i) { return i.product_type === 'Set'; });

    if (sets.length) {
      // Cart lines are newest first, so the first set line is the one added last.
      var anchor = opts.anchor && inCart(opts.anchor) ? opts.anchor : sets[0].handle;

      var open = (data.sets || []).filter(function (s) { return available(s) && !inCart(s.handle); });
      var set = null;
      var fourColor = anchor === data.og || (data.four || []).indexOf(anchor) !== -1;
      if (fourColor && data.og_first) {
        set = open.filter(function (s) { return s.handle === data.og_first; })[0] || null;
      }
      if (!set) {
        var anchorColors = colorsOf(anchor);
        set = open.filter(function (s) { return s.handle !== anchor && !shares(colorsOf(s.handle), anchorColors); })[0] || null;
      }
      if (set) {
        // The line under the set steps up with how many sets are already in the cart.
        var setCount = 0;
        sets.forEach(function (i) { setCount += i.quantity; });
        var setNote = setCount <= 1 ? 'Add a second set. More colors, more fun.'
          : setCount === 2 ? 'Another one? Makes a great gift.'
          : setCount === 3 ? 'Why not? The more, the flabbier.'
          : 'Now we\u2019re partying. Never run short on flabs.';
        list.push({ kind: 'set', handle: set.handle, title: set.title, variant: set.variant, qty: 1, price: set.price, price_text: money(set.price), note: setNote, image: set.image });
      }

      var used = [];
      sets.forEach(function (i) { used = used.concat(colorsOf(i.handle)); });
      var pack = expansionPack(used);
      if (pack) list.push(pack);

      if (available(target) && !inCart(target.handle)) {
        list.push(flabItem(target, 'target', 1, 'A spare target.'));
      }
    } else {
      // Only flabs (expansion packs or singles) so far.
      var lines = [];
      cart.items.forEach(function (i) {
        var fl = flabLine(i);
        if (!fl) return;
        var line = lines.filter(function (l) { return l.handle === fl.flab.handle; })[0];
        if (line) line.qty += fl.count; else lines.push({ handle: fl.flab.handle, qty: fl.count });
      });
      if (!lines.length) return [];

      // A target is one flab beyond the full packs: the target product first, else a color
      // with at least one full pack plus one (5 red). A lone flab of a color is a player's
      // flab, not a target, so it gets a top-up and the target is suggested.
      var odd = lines.filter(function (l) { return l.qty % PACK === 1; });
      var tLine = odd.filter(function (l) { return target && l.handle === target.handle; })[0] ||
        odd.filter(function (l) { return l.qty > PACK; })[0];
      var topups = [];
      lines.forEach(function (l) {
        var left = l.qty % PACK;
        if (!left || l === tLine) return;
        var f = flabByHandle(l.handle);
        if (!available(f)) return;
        var need = PACK - left;
        var color = shortName(f.title).toLowerCase();
        topups.push(flabItem(f, 'topup', need, 'Makes ' + (l.qty + need) + ' ' + color + ' so every player has a full set.', need + ' more ' + color + (need > 1 ? ' flabs' : ' flab')));
      });

      // 1) a top-up while any color is short of a full pack, else an expansion pack in a new
      // color, 2) the target if there isn't one, 3) the rope tool (below), then more top-ups.
      var first = topups.length ? topups.shift() : expansionPack([]);
      if (first) list.push(first);
      if (!tLine && available(target)) list.push(flabItem(target, 'target', 1, 'Every game needs a target.'));
      list = list.concat(topups);

      var rope = data.rope;
      if (available(rope) && !inCart(rope.handle)) {
        var r = flabItem(rope, 'rope', 1, 'Measures the close ones and wraps your set to carry.');
        if (list.length >= 3) list.splice(2, list.length - 2, r); else list.push(r);
      }
    }

    // Tag anything that gets the cart to free shipping (the order stays as set above).
    var gap = (parseInt(data.free_shipping, 10) || 7500) - cart.total_price;
    list.forEach(function (a) { a.unlocks = gap > 0 && a.price >= gap; });
    return list.slice(0, 3);
  }

  // Heading over the suggestions: a set in the cart means they're adding to a game they have.
  function heading(cart) {
    var hasSet = !!cart && cart.items.some(function (i) { return i.product_type === 'Set'; });
    return hasSet ? 'More flabs, more fun' : 'Complete your set';
  }

  window.FlabUpsellRules = { suggestions: suggestions, heading: heading, money: money };
})();
